module.exports = __webpack_public_path__ + "static/media/saveDraftIcon.113d2694.svg";